/**
 * HOPERY Warenkorb-Drawer
 * - Geschenk automatisch hinzufügen/entfernen (Daten aus <hopery-cart-sync> im Drawer)
 * - Geschenk-Sorte wechseln
 * - Empfehlungen per "Hinzufügen" in den Warenkorb legen
 * Nach jeder Änderung lädt der Drawer sich über das Theme-Event "cart:refresh" neu.
 */
(function () {
  if (window.HoperyCart) return;

  const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const state = { busy: false, actions: [] };

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then((response) => response.json().then((json) => {
      if (!response.ok) throw json;
      return json;
    }));
  }

  function refresh() {
    // Auf der Warenkorb-Seite gibt es eine zweite Darstellung, die neu geladen werden muss.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // Schutz gegen Endlosschleifen: höchstens 4 automatische Änderungen in 10 Sekunden.
  function allowAction() {
    const now = Date.now();
    state.actions = state.actions.filter((t) => now - t < 10000);
    if (state.actions.length >= 4) return false;
    state.actions.push(now);
    return true;
  }

  class HoperyCartSync extends HTMLElement {
    connectedCallback() {
      setTimeout(() => this.sync(), 0);
    }

    sync() {
      if (state.busy) return;
      let data;
      try {
        data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {
        return;
      }
      const lines = data.lines || [];
      const giftQty = lines.reduce((sum, line) => sum + line.quantity, 0);
      let request = null;

      if (data.eligible) {
        if (giftQty === 0 && data.defaultVariant) {
          request = ['cart/add.js', { items: [{ id: data.defaultVariant, quantity: 1, properties: { _hopery_gift: '1' } }] }];
        } else if (giftQty > 1) {
          const updates = {};
          lines.forEach((line, i) => { updates[line.key] = i === 0 ? 1 : 0; });
          request = ['cart/update.js', { updates }];
        }
      } else if (giftQty > 0) {
        const updates = {};
        lines.forEach((line) => { updates[line.key] = 0; });
        request = ['cart/update.js', { updates }];
      }

      if (!request || !allowAction()) return;
      state.busy = true;
      post(request[0], request[1])
        .catch((e) => console.error('HOPERY Geschenk:', e))
        .finally(() => {
          state.busy = false;
          refresh();
        });
    }
  }
  if (!customElements.get('hopery-cart-sync')) customElements.define('hopery-cart-sync', HoperyCartSync);

  // Geschenk-Sorte wechseln
  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('[data-hopery-gift-select]');
    if (!select || state.busy) return;
    const row = select.closest('.product-cart-item');
    if (row) row.classList.add('thb-loading');
    state.busy = true;
    post('cart/add.js', { items: [{ id: Number(select.value), quantity: 1, properties: { _hopery_gift: '1' } }] })
      .then(() => post('cart/update.js', { updates: { [select.dataset.key]: 0 } }))
      .catch((e) => console.error('HOPERY Sorte:', e))
      .finally(() => {
        state.busy = false;
        refresh();
      });
  });

  // Empfehlung hinzufügen
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-hopery-add]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    post('cart/add.js', { items: [{ id: Number(button.dataset.hoperyAdd), quantity: 1 }] })
      .then((response) => {
        const item = response && response.items ? response.items[0] : response;
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: item } }));
        refresh();
      })
      .catch((e) => {
        console.error('HOPERY Empfehlung:', e);
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  });

  // Scrollposition halten: Nach +, −, Entfernen, Sorte oder Hinzufügen lädt der Drawer neu.
  // Danach wieder an die Stelle scrollen, an der man vorher war (statt nach oben zu springen).
  const SCROLLERS = ['#Cart-Drawer .side-panel-inner', '#Cart-Drawer .side-panel-content'];
  const keep = { until: 0, pos: {}, changed: 0 };

  function remember() {
    SCROLLERS.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) keep.pos[sel] = el.scrollTop;
    });
  }

  function restore() {
    if (Date.now() > keep.until) return;
    SCROLLERS.forEach((sel) => {
      const el = document.querySelector(sel);
      const top = keep.pos[sel];
      if (el && top !== undefined && Math.abs(el.scrollTop - top) > 2) el.scrollTop = top;
    });
  }

  document.addEventListener('scroll', (event) => {
    const el = event.target;
    // Scrollen durch eigenes Wischen merken, nicht den Sprung beim Neuladen.
    if (!el || !el.matches || Date.now() - keep.changed < 600) return;
    SCROLLERS.forEach((sel) => { if (el.matches(sel)) keep.pos[sel] = el.scrollTop; });
  }, true);

  ['pointerdown', 'click', 'change'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const target = event.target;
      if (!target || !target.closest || !target.closest('#Cart-Drawer')) return;
      if (!target.closest('button, input, select, cart-remove, remove-all, quantity-selector, [data-hopery-add]')) return;
      remember();
      keep.until = Date.now() + 8000;
    }, true);
  });

  let restoreFrame = 0;
  new MutationObserver(() => {
    if (Date.now() > keep.until) return;
    keep.changed = Date.now();
    cancelAnimationFrame(restoreFrame);
    restoreFrame = requestAnimationFrame(restore);
  }).observe(document.body, { childList: true, subtree: true });

  window.HoperyCart = { refresh };
})();
